import ContactsForm from "./addContacts";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  onClose: Function;
};

const AddContacts = ({ toggleModal, urlTittle, onClose }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={"Agregar una persona de contacto"}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={() => {onClose()}}
      >
        <ContactsForm onClose={() => {onClose()}}/>
      </Modal>
    </>
  );
};

export default AddContacts;
